import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["tokens", "img", "children", "hoverable", "href", "tag"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { transparentize } from 'polished';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './CustomerCard.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var BaseCustomerCard = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var tokens = _ref.tokens,
      img = _ref.img,
      children = _ref.children,
      _ref$hoverable = _ref.hoverable,
      hoverable = _ref$hoverable === void 0 ? false : _ref$hoverable,
      href = _ref.href,
      tag = _ref.tag,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsx(views.Wrapper, _objectSpread(_objectSpread(_objectSpread({
    as: tag,
    img: img,
    hoverable: hoverable,
    href: href,
    ref: ref
  }, tokens), rest), {}, {
    children: children
  }));
});

var defaultHoverGradient = function defaultHoverGradient(theme) {
  return "linear-gradient(\n  180deg,\n  ".concat(transparentize(1, theme.palette.brand.darkAcai[800]), " 50%,\n  ").concat(transparentize(0.8, theme.palette.neutrals.black[100]), " 100%\n),\nlinear-gradient(\n  0deg,\n  ").concat(transparentize(0.84, theme.palette.brand.darkAcai[800]), " 33%,\n  ").concat(transparentize(0.2, theme.palette.brand.darkAcai[600]), " 95%\n)");
};

var defaultTheme = function defaultTheme(theme) {
  return {
    staticBackgroundGradient: "linear-gradient(\n    180deg,\n    ".concat(transparentize(1, theme.palette.brand.darkAcai[800]), " 100%,\n    ").concat(transparentize(0.2, theme.palette.neutrals.black[100]), " 100%\n  ),\n  linear-gradient(\n    0deg,\n    ").concat(transparentize(0.84, theme.palette.brand.darkAcai[800]), " 50%,\n    ").concat(transparentize(0.2, theme.palette.neutrals.black[100]), " 100%\n  )"),
    hoverBackgroundColor: theme.palette.brand.darkAcai[600],
    beforeHoverBackgroundGradient: defaultHoverGradient(theme),
    afterHoverBackgroundGradient: defaultHoverGradient(theme),
    afterHoverBackgroundBlendMode: "luminosity",
    beforeHoverBackgroundBlendMode: "luminosity"
  };
};

var twilioLightStaticBackgroundGradient = function twilioLightStaticBackgroundGradient(theme) {
  return "\nlinear-gradient(\n  180deg,\n  ".concat(transparentize(0.86, theme.palette.twilio.gray[80]), " 50%,\n  ").concat(transparentize(0.3, theme.palette.twilio.gray[80]), " 100%\n  ),\nlinear-gradient(\n  0deg,\n  ").concat(transparentize(0.86, theme.palette.twilio.gray[80]), " 50%,\n  ").concat(transparentize(0.3, theme.palette.twilio.gray[80]), " 100%\n  )");
};

export var CustomerCard = withDesignTokens(BaseCustomerCard, function () {
  return {};
}, {
  light: defaultTheme,
  dark: defaultTheme,
  twilioLight: function twilioLight(theme) {
    return {
      staticBackgroundGradient: twilioLightStaticBackgroundGradient(theme),
      hoverBackgroundColor: theme.palette.twilio.gray[20],
      beforeHoverBackgroundGradient: "linear-gradient(\n        0deg,\n        ".concat(theme.palette.twilio.gray[20], ", \n        ").concat(theme.palette.twilio.gray[20], "\n        ),\n      linear-gradient(\n        180deg,\n        ").concat(transparentize(0.8, theme.palette.twilio.gray[80]), " 50%, \n        ").concat(theme.palette.twilio.gray[80], " 100%\n        ),\n      linear-gradient(\n        0deg,\n        ").concat(transparentize(0.8, theme.palette.twilio.gray[80]), " 50%, \n        ").concat(theme.palette.twilio.gray[80], " 100%\n        )"),
      afterHoverBackgroundGradient: twilioLightStaticBackgroundGradient(theme),
      beforeHoverBackgroundBlendMode: "color, multiply, multiply, normal",
      afterHoverBackgroundBlendMode: "multiply, multiply, normal"
    };
  }
});
export var Row = function Row(_ref2) {
  var children = _ref2.children;
  return _jsx(views.RowWrapper, {
    children: children
  });
};